/**
 * Represents a query expression segment
 */
export class QuerySegment {
  /**
   * The type of the expression
   */

  /**
   * Check if value is a template string
   * @param {string} value The String value to be checked
   * @returns {boolean} whether the value is a template string
   */
  isTemplateValue(value) {
    return new RegExp('^@@.*@@$').test(value);
  }
  /**
   * The String value of the current Query expression
   */


  /**
   * A '.SORT' Content Query segment
   * @param {K} field The name of the field
   * @param {boolean} reverse Sort in reverse order, false by default
   */
  sort(field) {
    let reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    this.stringValue = ` .${reverse ? 'REVERSESORT' : 'SORT'}:${field}`;
    this.segmentType = 'sort';
    return this.finializeSegment();
  }
  /**
   * A '.TOP' Content Query segment
   * @param {number} topCount The TOP item count
   */


  top(topCount) {
    this.stringValue = ` .TOP:${topCount}`;
    this.segmentType = 'top';
    return this.finializeSegment();
  }
  /**
   * Adds a '.SKIP' Content Query segment
   * @param {number} skipCount Items to skip
   */


  skip(skipCount) {
    this.stringValue = ` .SKIP:${skipCount}`;
    this.segmentType = 'skip';
    return this.finializeSegment();
  }
  /**
   * Adds a '.AUTOFILTERS' Content Query segment
   * @param {string} filterType type of autofilter
   */


  autofilters(filterType) {
    this.stringValue = ` .AUTOFILTERS:${filterType}`;
    this.segmentType = 'autofilters';
    return this.finializeSegment();
  }
  /**
   * Creates a content query segment from a QuerySegment object
   * @returns {string} a segment string value
   */


  toString() {
    return this.stringValue;
  }

  constructor(queryRef) {
    this.queryRef = queryRef;
    this.segmentType = void 0;
    this.stringValue = '';
  }
  /**
   * Finializes the Query segment
   */


  finializeSegment() {
    this.queryRef.addSegment(this);
    return new QuerySegment(this.queryRef);
  }

}
//# sourceMappingURL=QuerySegment.js.map